import React, { Fragment, useCallback } from 'react'
import './DialList.css'
import NotCalled from '../../../../assets/ringTypes/NotCalled.png'
import CallBackCall from '../../../../assets/ringTypes/CallBackCall.png'
import { useTranslation } from "react-i18next";

const DialList = (props) => {
    const [t] = useTranslation('common')
    const appAccess = props.appAccess
    let callStatusHeb = null
    let icon = NotCalled
    if (props.CallStatus === 'notactive') callStatusHeb = t('Not active')
    if (props.CallStatus === 'waiting') callStatusHeb = t('Waiting')
    if (props.CallStatus === 'postponed') callStatusHeb = t('Rejected')
    if (props.CallStatus === 'bore') callStatusHeb = t('Snooze')
    if (props.projectDesc) icon = CallBackCall
    let cardColor = 'row card chatCard'
    if (!props.selectMultipleBtnClicked && (props.dialItemSelected._id === props._id && props.dialItemSelected.telephone === props.telephone)) {
        cardColor = 'row card chatCard chatCardOnSelect'
    }
    else if (props.selectMultipleBtnClicked && props.isDialListMultiSelected) {
        cardColor = 'row card chatCard chatCardOnSelect'
    }
    let title = null
    if (!props.name) {
        title = props.telephone.replace('+972', '0');
    }
    else {
        title = props.name;
    }
    const OnNewConvChannelSelected = props.OnNewConvChannelSelected
    const onNewConvName = props.onNewConvName
    const OnNewConvClicked = props.OnNewConvClicked
    const onChannelSelect = useCallback((channelId, msgType) => {
        OnNewConvChannelSelected(msgType)
        onNewConvName(channelId)
        setTimeout(() => OnNewConvClicked(), 0)

    }, [OnNewConvClicked, onNewConvName, OnNewConvChannelSelected])
    
    return (
        <Fragment>
            <div className={cardColor} onClick={props.OnDialItemSelected}>

                <div className='col-10 col-md-9 costContactsTextCol'>
                    <div className='card-body chatCardBody'>
                        <p className='mutedP'>{props.startTime}</p>
                        <p className='contactCardTitle'>{title}{props.projectDesc && <i title={t('Callback from') + props.projectDesc} className="fas fa-voicemail cusVoiceMailDialList" />} </p>
                        <p className='dialListCardText'> {props.desc} <span className='callStatus'>{callStatusHeb}</span></p>
                        <div className='containerDialList'>
                            <div className='dialListItem_channelsPanel'>
                                {appAccess !== 'DIALER' && <i className="fab fa-whatsapp-square dialListItem_channelsPanel_whatsapp" onClick={() => onChannelSelect(props.telephone.split('_')[0], 'whatsapp')} />}
                                {appAccess !== 'DIALER' && <i className="fas fa-sms dialListItem_channelsPanel_sms" onClick={() => onChannelSelect(props.telephone.split('_')[0], 'sms')} />}
                            </div>
                            <div>
                                {props.isContactIdAvailabileDialList?._id ? <i className="fa-regular fa-pen-to-square chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('edit', 'DIALLIST')}></i> : <i className="fa-solid fa-plus chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('add', 'DIALLIST')}></i>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-2 col-md-3 costContactsCol'>
                    <div className='dialListIcon'>
                        <img src={icon} onClick={props.CallBtClicked} className='dialListImg' alt='...' />
                    </div>
                </div>
            </div>
            <hr className="dividingLineBetChats" />
        </Fragment>
    )
};

export default DialList;